import { Email as EmailIcon } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Advisors from "../components/about/Advisors";
import Coaches from "../components/about/Coaches";
import OriginStory from "../components/about/OriginStory";
import VisionAndPrinciples from "../components/about/VisionAndPrinciples";

const About: React.FC = () => {
    return (
        <Box>
            <OriginStory />
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <VisionAndPrinciples />
                <Advisors />
                <Coaches />

                {/* Contact CTA */}
                <Box
                    sx={{
                        textAlign: "center",
                        py: 6,
                        px: 4,
                        borderRadius: 2
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            mb: 2,
                            fontWeight: "bold"
                        }}
                    >
                        Ready to Get Started?
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 4,
                            color: "text.secondary",
                            maxWidth: 600,
                            mx: "auto"
                        }}
                    >x
                        Contact us now to learn more about how Strong Mind Strong Performance can help your athlete reach their full potential.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<EmailIcon />}
                        component={Link}
                        to="/contact"
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: "1.1rem",
                            fontWeight: "bold"
                        }}
                    >
                        Contact Us Now
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default About;
